import { render } from "./CadastroCliente.vue?vue&type=template&id=27c9528c"
import script from "./CadastroCliente.vue?vue&type=script&lang=ts"
export * from "./CadastroCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script